<template>
  <v-flex data-qa="deposits-flex-fk73ba">
    <Loader v-show="loaderEnabled"/>
    <v-layout wrap class="ml-2 pt-0" data-qa="deposits-layout-5b7eda">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient }"
       data-qa="deposits-flex-k6ieok">
        <v-container data-qa="deposits-container-9wjfy5">
          <v-flex xs12 sm12 md12 lg12 xl12 class="px-2" data-qa="deposits-flex-heul3z">
            <v-flex xs12 sm10 md10 lg8 xl7 data-qa="deposits-flex-kthbv">
              <v-row no-gutters class="pb-2" data-qa="deposits-row-hsy9gm">
                  <inline-svg
                    class="mt-2"
                    :src="getNavigationIcon()"
                    width="50"
                    height="50"
                    aria-label="Navigation Icon"
                  ></inline-svg>
                  <font class="display-1 font-weight-thin white--text pt-4 pl-2">
                    {{ depositTitle }} <font v-if="showTotalAccountsAvailable">({{ depositsAccCopy.length }})</font>
                  </font>
              </v-row>
            </v-flex>
            <v-row class="px-2 pl-6" data-qa="deposits-row-xlo7hi">
              <v-layout v-if="showTotalBalance" row wrap data-qa="deposits-layout-uo0e89">
                <v-layout row wrap data-qa="deposits-layout-36n4y">
                <v-flex xs12 sm12 md12 lg12 xl12 class="px-1" data-qa="deposits-flex-0qmh9v">
                  <font class="subheading-1 font-weight-medium white--text"
                    >{{ $t("termdepositDetails.totalAmtLabel")}}</font
                  >
                </v-flex>
                <v-flex xs12 sm12 md12 lg12 xl12 class="px-1" data-qa="deposits-flex-t4mitk">
                  <font class="text-h5 font-weight-bold white--text">{{
                    $formatter.currency.format(accDetails.myBalance, accDetails.currency)
                  }}</font>
                </v-flex>
                </v-layout>
              </v-layout>

              <v-layout v-if="enableOpenNewAccountOption" class="py-2" data-qa="deposits-layout-tovvu">
                <v-flex sm12 xs12 md12 lg12 xl12 class="text-right" data-qa="deposits-flex-ivl90s">
                  <v-btn
                    @click="goToOffer('TD')"
                    color="white"
                    class="text-none py-2 px-4"
                    outlined
                     data-qa="deposits-btn-ul1cos">{{ $t("termdepositDetails.openNewAC")}}</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex xs12 sm12 md12 lg9 xl9 class="pl-1 mt-4" data-qa="deposits-flex-ehet7e">
      <div v-if="filterChips" class="py-2" data-qa="deposits-div-arjxy">
        <v-chip
          v-for="(search, i) in filterableStatuses"
          :key="search"
          outlined
          class="ma-2"
          :color="primaryColor"
          @click="selectStatus(search)"
          @click:close="filterChips = false"
          :data-qa="`deposits-chip-w2x8g-${i}`"
        >
          <font class="text-capitalize">{{
            $t(`systemEnums.termDeposit.${search}`)
          }}</font>
        </v-chip>
        <span class="pl-2" data-qa="deposits-span-i7qv7">
          <v-btn
            v-if="!disableFilterReset"
            @click="selectStatus('reset')"
            :disabled="disableFilterReset"
            :color="secondaryColor"
            outlined
            class="body-2 text-capitalize pa-2 py-2 px-4"
           data-qa="deposits-btn-09oybd">
            <v-icon :disabled="disableFilterReset" :color="secondaryColor" left size="18px"
              class="material-symbols-outlined"
               data-qa="deposits-icon-hmzqc">refresh</v-icon
            >
            {{ $t("termdepositDetails.btnResetFilter")}}
          </v-btn></span
        >
      </div>
      <CardLayout :config="depositAccount" />
    </v-flex>
  </v-flex>
</template>

<script>
// import '@/styles/pages/accounts/deposits.scss'
import _ from 'lodash'
import CardLayout from '@/views/home/HomeCards.vue'
import preload from '@/util/preload'
import store from '@/core/store'
import event from '@/util/event'
import Loader from '../../components/common/Loader.vue'

export default {
  name: 'Deposits',
  components: {
    Loader,
    CardLayout
  },
  data () {
    return {
      filterChips: true,
      filterableStatuses: [],
      depositsAccCopy: [],
      accountType: 'TD',
      loaderEnabled: false,
      disableFilterReset: true,
      depositAccount: {
        title: this.$t('common.depositTypeLabel'),
        cardLabels: false,
        openNewACCard: false,
        enableShowMore: false,
        accounts: []
      },
      accDetails: {
        myBalance: 0,
        currency: '',
        series: []
      },
      depositTitle: '',
      showTotalBalance: this.$appSettings.defaultConfigurations.totalBalanceSection.enableDepositSection,
      showTotalAccountsAvailable: this.$appSettings.defaultConfigurations.showTotalAccountsAvailable.enableDepositSection,
      enableOpenNewAccountOption: this.$appSettings.defaultConfigurations.enableOpenNewAccountOption
    }
  },
  beforeCreate () {
    const reloadDeposit = sessionStorage.getItem('reloadDeposit')
    if (this.$route.params.reload || JSON.parse(reloadDeposit)) {
      location.reload()
      sessionStorage.setItem('reloadDeposit', false)
    }
  },
  created () {
    this.depositTitle = this.$appSettings.defaultConfigurations.landingPageConfig.enableUkMarketSavingAccInDashboard
      ? this.$t('common.savingsSubTitle_3')
      : this.$t('termdepositDetails.label')
    if (this.$route.params && this.$route.params.from === 'Dashboard') {
      this.depositAccount.enableShowMore = true
    } else this.depositAccount.enableShowMore = false
    const exclusionList = this.$appSettings.uiFieldsDisplayConfigurations
      .tableColumns.accountListTables.exclusionList
    event.$on('set_myAccounts', () => {
      // this.fetchAccounts()
      this.getListOfAccounts()
      this.loaderEnabled = false
    })
    if (this.ifMyAccountsAvailable()) {
      // this.fetchAccounts()
      this.getListOfAccounts()
    } else {
      this.loaderEnabled = true
      preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
    }
    if (exclusionList && exclusionList.length) {
      this.depositAccountList.headers = preload.filterTableColumns(
        exclusionList,
        this.depositAccountList.headers
      )
    }
  },
  methods: {
    getNavigationIcon () {
      return this.getSvgIconSrc('Deposit2')
    },
    goToOffer (type) {
      this.$router.push('/depositsProducts')
      // this.$router.push({ name: 'ApplyNow', params: { offerType: type } })
    },
    selectStatus (selectedStatus) {
      this.loaderEnabled = true
      const arr = [...this.depositsAccCopy]
      this.depositAccount.accounts = []

      if (selectedStatus !== 'reset') {
        arr.forEach((item) => {
          if (selectedStatus === item.status) {
            this.depositAccount.accounts.push(item)
          }
        })
        this.disableFilterReset = false
        event.$emit('updateCards', this.depositAccount.accounts)
      } else {
        this.disableFilterReset = true
        this.depositAccount.accounts = [...arr]
        event.$emit('updateCards', this.depositAccount.accounts)
      }
      this.loaderEnabled = false
    },
    getListOfAccounts () {
      this.loaderEnabled = true
      const statuses = []
      const data = store.getters['userStore/userData'].myAccounts
      if (data) {
        this.depositAccount.accounts = data.deposits
          ? data.deposits.accountList
          : []
        if (this.depositAccount.accounts.length) {
          this.depositAccount.accounts = _.filter(this.depositAccount.accounts, account => { return !(this.$appSettings.uiFieldsDisplayConfigurations.TDAccountListing.exclusionList.includes(account.status)) })
        }
        this.depositsAccCopy = this.depositAccount ? this.depositAccount.accounts : []
        // this.depositsAccCopy = data.deposits ? data.deposits.accountList : []

        this.depositAccount.accounts.forEach((item) => {
          statuses.push(item.status)
        })
        this.filterableStatuses = [...new Set(statuses)]

        for (const i in data) {
          if (data[i].accountList[0]) {
            this.accDetails.currency = data[i].accountList[0].currency
          }
          switch (data[i].label) {
            case 'depositAccounts':
              this.accDetails.series.push(data[i].totalDepositBalance)
              this.accDetails.myBalance += data[i].totalDepositBalance
              break
            default:
              break
          }
        }
      }
      this.loaderEnabled = false
    },
    fetchAccounts () {
      this.loaderEnabled = true
      const accounts = store.getters['userStore/userData'].myAccounts
      const deposits = accounts.deposits.accountList
      if (deposits && deposits.length) {
        this.depositAccountList.list = []
        for (const i in deposits) {
          this.depositAccountList.list.push({
            ...deposits[i],
            accountName: deposits[i].customerName,
            status: this.$t(`systemEnums.termDeposit.${deposits[i].status}`),
            accountNumber: deposits[i].fixedDepositAccountId,
            balance: this.getBalInfo(deposits[i].balance)
          })
        }
        this.loaderEnabled = false
      } else {
        this.loaderEnabled = false
      }
    },
    ifMyAccountsAvailable () {
      return store.getters['userStore/userData'].myAccounts
    },
    getBalInfo (bal) {
      if (bal !== undefined && bal.toString().trim().length > 0) {
        if (isNaN(bal)) {
          return bal
        } else {
          return this.$formatter.currency.format(bal)
        }
      } else {
        return this.$t('myAccounts.notAvailableLabel')
      }
    }
  }
}
</script>
